import { FunctionComponent } from 'react';
import { CademyError } from '@shared/domain-shared';
import { Field } from '@shared/types';
import { Form } from '../Form';

const DEFAULT_FORM_FIELDS: Array<Field> = [
    {
        _id: 'system_first_name',
        label: 'First Name',
        data_type: 'first_name',
        educator_ref: '',
        created_at: 0,
        updated_at: 0,
    },
    {
        _id: 'system_last_name',
        label: 'Last Name',
        data_type: 'last_name',
        educator_ref: '',
        created_at: 0,
        updated_at: 0,
    },
    {
        _id: 'system_email',
        label: 'Email',
        data_type: 'email',
        educator_ref: '',
        created_at: 0,
        updated_at: 0,
    },
];

export type DefaultFormProps = {
    disabled?: boolean;
    error: CademyError | null;
    disabledFields?: Array<Field['_id']>;
};
export const DefaultForm: FunctionComponent<DefaultFormProps> = (props) => {
    return <Form fields={DEFAULT_FORM_FIELDS} {...props} />;
};
